import { HUMANIZER_PROMPT, HUMANIZER_STYLES } from '../prompts/humanizer';

export function getHumanizerContext(): string {
    const style = HUMANIZER_STYLES[Math.floor(Math.random() * HUMANIZER_STYLES.length)];
    return `\n${HUMANIZER_PROMPT}\nToday's conversation style: ${style}. Don't announce this.`;
}
